import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=2f4d99d5&scoped=true&"
import script from "./FollowUp.vue?vue&type=script&lang=js&"
export * from "./FollowUp.vue?vue&type=script&lang=js&"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=2f4d99d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d99d5",
  null
  
)

export default component.exports